import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  selectAuthActingAsClientId,
  selectAuthActingAsEmail,
  selectAuthActingAsLabel,
} from "../../../../store/selectors/auth";
import { returnToAgency } from "../../../../store/agency/slice";
import { CloseIcon } from "../../../icons";
import Button from "../../../Button/Button";

import styles from "./AgencyClientMode.module.css";

const AgencyClientMode: FC = () => {
  const dispatch = useDispatch();
  const clientId = useSelector(selectAuthActingAsClientId);
  const label = useSelector(selectAuthActingAsLabel);
  const email = useSelector(selectAuthActingAsEmail);

  const displayName = label || email || clientId;

  const handleExit = () => {
    dispatch(returnToAgency());
  };

  return (
    <div className={styles["mode"]}>
      <div className={styles["mode__content"]}>
        <span className={styles["mode__label"]}>Agency</span>
        <p className={styles["mode__description"]}>{displayName}</p>
      </div>
      <Button
        className={styles["mode__button"]}
        typeStyle="round-outline"
        Icon={CloseIcon}
        onClick={handleExit}
        aria-label="Exit client account"
      />
    </div>
  );
};

export default AgencyClientMode;
